import { CustomPropTypes } from '@philips-emr/tws-core/lib/component';
import { DummyObject } from '@philips-emr/tws-core/lib/registry/component-info';

import ComponentNode from '../core/component-node';
import FragmentNode from '../core/fragment-node';
import { NodeProps, Props } from '../metadata';
import { resolveProps } from '../util';

function diffObjects(objA: Props = {}, objB: Props = {}): Props {
  const obj: Props = {};
  return Object.keys(objB).reduce((diff, key) => {
    if (objB[key] !== objA[key]) {
      diff[key] = objB[key];
    }

    return diff;
  }, obj);
}

function getUniqueProperties(objA: Props = {}, objB: Props = {}): Props {
  const diff: Props = {};
  for (const key in objB) {
    if (!(key in objA)) {
      diff[key] = objB[key];
    }
  }

  return diff;
}

class PropsProcessor {

  node: ComponentNode;
  parent: FragmentNode;

  defaultProps: DummyObject;
  events: string[];

  lastProps: Props = {};

  constructor(node: ComponentNode, parent: FragmentNode) {
    this.node = node;
    this.parent = parent;

    const renderable = node.getRenderable();
    const propTypes = renderable.propTypes || {};

    this.defaultProps = renderable.defaultProps || {};
    this.events = Object.keys(propTypes).filter(p => propTypes[p] === CustomPropTypes.eventListener);
  }

  removeProperties(props: Props, properties = []): Props {
    const copy = { ...props };

    properties.forEach((property) => {
      delete copy[property];
    });

    return copy;
  }

  processMetaProps(rawMetaProps: NodeProps, breakpoint?: string, locale?: string): Props {
    return resolveProps(rawMetaProps, breakpoint, locale);
  }

  processProps(metaProps: Props, ssotProps: Props, props: Props): Props {
    const changedProps = diffObjects(this.lastProps, props);

    const relevantProps = getUniqueProperties(metaProps, changedProps);

    this.lastProps = props;

    return { ...ssotProps, ...relevantProps };
  }

  collect(props: Props, breakpoint: string, locale: string): Props {
    const ssot = this.node.getSSOT();
    const metadata = this.node.getNodeMetadata();

    const metaProps = this.processMetaProps(metadata.props, breakpoint, locale);
    const ssotProps = this.processProps(metaProps, ssot.props, props);

    ssot.setMetaProps(metaProps);
    ssot.setProps(ssotProps);

    return { ...ssot.metaProps, ...ssot.props };
  }

}

export default PropsProcessor;
